import apiClient from "../../../utilities/apiClient";

export const addMaterialGroup = (payload) => {
  return apiClient.post(`${apiClient.Urls.material_group}`, payload, true);
};

export const getMaterialGroups = (page, per_page, search) => {
  return apiClient.get(
    `${apiClient.Urls.material_group}?page=${page}&per_page=${per_page}&search=${
      search || ""
    }`,
    "",
    true
  );
};

export const updateMaterialGroup = (id, payload) => {
  return apiClient.put(`${apiClient.Urls.material_group}/${id}`, payload, true);
};

export const deleteMaterialGroup = (id) => {
  return apiClient.delete(`${apiClient.Urls.material_group}/${id}`, {}, true);
};
